import type { Batch } from '@ctcells/contract'
import { enumLabel, t } from '@ctcells/i18n'

import type { ValueRow } from '../../atoms/ValueRows.tsx'
import { clockText } from '../../shell/batchStripModel.ts'
import { fullDateTimeText, moduleLabelOf } from '../format.ts'

/**
 * 멈춤 정보(`HaltFacts`)의 줄 목록 — 순수 함수(시험이 직접 잰다). 컴포넌트 파일과 갈랐다(react-refresh — 컴포넌트 파일은
 * 컴포넌트만 내보낸다).
 */
export function haltFactRows(
  batch: Pick<Batch, 'halt_code' | 'halt_delay' | 'halt_module_id' | 'halt_remote_at'>,
  onOpenModule?: (moduleId: string) => void,
): ValueRow[] {
  const delay = batch.halt_delay
  const rows: ValueRow[] = []
  if (batch.halt_code != null && batch.halt_code !== '')
    rows.push({ key: 'code', label: t('halt.code'), value: batch.halt_code })
  if (delay?.since != null)
    rows.push({ key: 'since', label: t('halt.since'), value: fullDateTimeText(delay.since) })
  if (delay?.elapsed_paused_sec != null)
    rows.push({
      key: 'elapsed',
      label: t('halt.elapsed'),
      value: <span className="num">{clockText(delay.elapsed_paused_sec * 1000)}</span>,
    })
  if (delay?.max_allowed_delay_sec != null)
    rows.push({
      key: 'allowed',
      label: t('halt.allowed'),
      value: <span className="num">{clockText(delay.max_allowed_delay_sec * 1000)}</span>,
    })
  if (delay != null)
    rows.push({
      key: 'state',
      label: t('halt.delayState'),
      // 🔴 색만으로 말하지 않는다 — 글자가 판정을 말한다(넘음 · 80% 넘음 · 판정 불가)
      value: enumLabel('enum.haltDelay', delay.state),
    })
  const moduleId = batch.halt_module_id
  if (moduleId != null && moduleId !== '') {
    const text = `${moduleLabelOf(moduleId)} (${moduleId})`
    rows.push({
      key: 'module',
      label: t('halt.module'),
      value:
        onOpenModule === undefined ? (
          text
        ) : (
          <button className="lnk" onClick={() => onOpenModule(moduleId)} type="button">
            {text}
          </button>
        ),
    })
  }
  if (batch.halt_remote_at != null && batch.halt_remote_at !== '')
    rows.push({
      key: 'remote',
      label: t('halt.remoteAt'),
      value: fullDateTimeText(batch.halt_remote_at),
    })
  return rows
}
